<template>
  <div class="booking-form__package">
    <div class="container-fluid">
      <div class="row mt-6 mb-6" v-if="isPackageSelect">
        <div class="col">
          <h3 class="label text-lg">Specify Shipment Type</h3>

          <div class="d-flex mt-3 mb-4">
            <label class="radio-label" for="package">
              <input type="radio" id="package" :disabled="$route.query.consolidationId && getShipmentWeight > 5"
                v-model="packageShipmentType" value="LightPackage" />
              <template>
                <svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14.0487 7.90006C13.5271 7.90006 13.0365 7.62233 12.7711 7.17795L10.7868 3.88834L8.80566 7.17795C8.53718 7.62541 8.04652 7.90315 7.52499 7.90315C7.38613 7.90315 7.24726 7.88463 7.11456 7.84451L2.88683 6.63483V12.1278C2.88683 12.5814 3.19542 12.9764 3.63363 13.0844L10.3054 14.7539C10.6202 14.8311 10.9504 14.8311 11.2621 14.7539L17.94 13.0844C18.3782 12.9733 18.6868 12.5783 18.6868 12.1278V6.63483L14.4591 7.84143C14.3264 7.88155 14.1875 7.90006 14.0487 7.90006ZM20.6094 4.43764L19.0201 1.26529C18.9244 1.07397 18.7177 0.962873 18.5048 0.990646L10.7868 1.97506L13.6166 6.66877C13.7339 6.86319 13.9684 6.95576 14.1875 6.89405L20.2946 5.15049C20.6001 5.061 20.7482 4.72155 20.6094 4.43764ZM2.55355 1.26529L0.96429 4.43764C0.822336 4.72155 0.973547 5.061 1.27597 5.1474L7.38304 6.89096C7.60214 6.95268 7.83667 6.8601 7.95394 6.66569L10.7868 1.97506L3.06581 0.990646C2.85288 0.965959 2.64921 1.07397 2.55355 1.26529Z"
                    fill="#383F51" />
                </svg>
              </template>
              Light Package
              <span></span>
            </label>
            <label class="radio-label ml-4" for="Heavy">
              <input type="radio" id="Heavy" value="HeavyPackage" v-model="packageShipmentType" />
              <template>
                <svg width="26" height="20" viewBox="0 0 26 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M24.3798 11.25H20.9076V15L19.5187 14.168L18.1298 15V11.25H14.6576C14.2756 11.25 13.9631 11.5312 13.9631 11.875V19.375C13.9631 19.7188 14.2756 20 14.6576 20H24.3798C24.7617 20 25.0742 19.7188 25.0742 19.375V11.875C25.0742 11.5312 24.7617 11.25 24.3798 11.25ZM7.71311 8.75H17.4353C17.8173 8.75 18.1298 8.46875 18.1298 8.125V0.625C18.1298 0.28125 17.8173 0 17.4353 0H13.9631V3.75L12.5742 2.91797L11.1853 3.75V0H7.71311C7.33116 0 7.01866 0.28125 7.01866 0.625V8.125C7.01866 8.46875 7.33116 8.75 7.71311 8.75ZM10.4909 11.25H7.01866V15L5.62977 14.168L4.24089 15V11.25H0.768663C0.386719 11.25 0.0742188 11.5312 0.0742188 11.875V19.375C0.0742188 19.7188 0.386719 20 0.768663 20H10.4909C10.8728 20 11.1853 19.7188 11.1853 19.375V11.875C11.1853 11.5312 10.8728 11.25 10.4909 11.25Z"
                    fill="black" />
                </svg>
              </template>
              Heavy Package
              <span></span>
            </label>
            <label class="radio-label ml-4" for="Truck">
              <input type="radio" id="Truck" value="Truck" v-model="packageShipmentType" />
              <template>
                <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14.3272 12.4167C13.9957 12.4167 13.6777 12.285 13.4433 12.0505C13.2089 11.8161 13.0772 11.4982 13.0772 11.1667C13.0772 10.8351 13.2089 10.5172 13.4433 10.2828C13.6777 10.0484 13.9957 9.91666 14.3272 9.91666C14.6587 9.91666 14.9766 10.0484 15.2111 10.2828C15.4455 10.5172 15.5772 10.8351 15.5772 11.1667C15.5772 11.4982 15.4455 11.8161 15.2111 12.0505C14.9766 12.285 14.6587 12.4167 14.3272 12.4167ZM15.5772 4.91666L17.2105 6.99999H13.4939V4.91666H15.5772ZM4.32719 12.4167C3.99567 12.4167 3.67773 12.285 3.44331 12.0505C3.20888 11.8161 3.07719 11.4982 3.07719 11.1667C3.07719 10.8351 3.20888 10.5172 3.44331 10.2828C3.67773 10.0484 3.99567 9.91666 4.32719 9.91666C4.65871 9.91666 4.97665 10.0484 5.21107 10.2828C5.44549 10.5172 5.57719 10.8351 5.57719 11.1667C5.57719 11.4982 5.44549 11.8161 5.21107 12.0505C4.97665 12.285 4.65871 12.4167 4.32719 12.4167ZM15.9939 3.66666H13.4939V0.333328H1.82719C0.902189 0.333328 0.160522 1.07499 0.160522 1.99999V11.1667H1.82719C1.82719 11.8297 2.09058 12.4656 2.55942 12.9344C3.02826 13.4033 3.66415 13.6667 4.32719 13.6667C4.99023 13.6667 5.62611 13.4033 6.09496 12.9344C6.5638 12.4656 6.82719 11.8297 6.82719 11.1667H11.8272C11.8272 11.8297 12.0906 12.4656 12.5594 12.9344C13.0283 13.4033 13.6641 13.6667 14.3272 13.6667C14.9902 13.6667 15.6261 13.4033 16.095 12.9344C16.5638 12.4656 16.8272 11.8297 16.8272 11.1667H18.4939V6.99999L15.9939 3.66666Z"
                    fill="#383F51" />
                </svg>
              </template>
              Truck
              <span></span>
            </label>

          </div>
        </div>
      </div>
      <div>
        <truck-shipment-form v-if="packageShipmentType == 'Truck'" :shippingId="$store.getters.shippingId"
          ref="truckForm" :preWeight="getShipmentWeight" :preValue="getItemValue"
          :packageSavedCount="packageSavedCount" />
      </div>
      <div>
        <heavy-package-shipment-form v-if="packageShipmentType == 'HeavyPackage'" :preWeight="getShipmentWeight"
          :preValue="getItemValue" ref="heavyPackageForm" :packageSavedCount="packageSavedCount" />
      </div>
      <div>
        <light-package-shipment-form v-if="packageShipmentType == 'LightPackage'" :isLight="isLight"
          :preWeight="getShipmentWeight" :preValue="getItemValue" ref="lightPackageForm"
          :packageSavedCount="packageSavedCount" />
      </div>

      <div class="button-wrapper">
        <p class="cursor-pointer underline" @click="goBack">Back</p>
        <span class="">
          <base-button text="Continue" :loading="isLoading" @click="submitPackageInformation" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import TruckShipmentForm from "./TruckShipmentForm";
import LightPackageShipmentForm from "./LightPackageShipmentForm";
import HeavyPackageShipmentForm from "./HeavyPackageShipmentForm";

export default {
  name: "package-form",
  components: {
    TruckShipmentForm,
    HeavyPackageShipmentForm,
    LightPackageShipmentForm,
  },
  data() {
    return {
      newPackage: {
        userId: "",
        type: "",
        quantity: "",
        length: "",
        width: "",
        height: "",
        weight: "",
        packagingType: "",
        description: "",
        value: "",
        specialHandling: "",
        specialHandlingRadio: "no",
        shippingId: "",
      },
      isLoading: false,
      handlingOptions: [
        "Fragile",
        "Over-sized",
        "Over-weight",
        "Flammable",
        "Radioactive",
      ],
      selectedHandlingOptions: [],
      heavyPackages: [
        {
          type: "",
          quantity: "",
          length: "",
          width: "",
          height: "",
          weight: "",
          packagingType: "",
          description: "",
          value: "",
          specialHandlingRadio: "no",
          specialHandling: "",
        },
      ],
      lightPackages: [
        {
          name: "",
          description: "",
          quantity: "",
          itemValue: "",
          isSpecialHandling: false,
          specialHandling: "",
        },
      ],
      packageShipmentType: "LightPackage",
      isAccordionBody: false,
      isPackageSelect: true,
      packageSavedCount: 0
    };
  },
  mounted() {
   
  },
  methods: {
    isLight() {
      return this.packageShipmentType == 'LightPackage'
    },
    async submitPackageInformation() {

      console.log(this.validator());
      this.isLoading = true;
      let payload = null;
      if (this.packageShipmentType == "LightPackage") {
        payload = this.$refs.lightPackageForm.returnPayload();
      } else if (this.packageShipmentType == "HeavyPackage") {
        payload = this.$refs.heavyPackageForm.returnPayload();
      } else if (this.packageShipmentType == "Truck") {
        payload = this.$refs.truckForm.returnPayload();
      }
      this.$store.dispatch("saveBookingInformation", {
        property: "packageType",
        value: this.packageShipmentType,
      });

      try {
        const response = await this.$_submitPackageInformation(payload);
        this.handleResponse(response);

        this.packageSavedCount += 1

        this.$store.dispatch("savePackages", response.data.packages);
      } catch (error) {
        this.handleError(error);
      }
      this.isLoading = false;
    },
    validator() {
      let payload = null;
      let pass = false;
      if (this.packageShipmentType == "LightPackage") {
        payload = this.$refs.lightPackageForm.returnPayload();
      } else if (this.packageShipmentType == "HeavyPackage") {
        payload = this.$refs.heavyPackageForm.returnPayload();
      } else if (this.packageShipmentType == "Truck") {
        payload = this.$refs.truckForm.returnPayload();
      }

      // return payload;
      payload.forEach(x => {

        console.log(x.shipmentCategory.length)
        if (x.shipmentCategory.length == 0) {
          pass = true
        }
        //  == 0 ? true : false
        console.log(pass)
      })
      return pass
    },
    handleResponse(response) {
      this.$store.dispatch("saveBookingInformation", {
        property: "newPackage",
        value: response.data.packages,
      });
      this.$store.dispatch("saveLastCompletedFormNo", 3);
      const packageIds = [];
      response.data.packages.forEach((item) => {
        packageIds.push(item.id);
      });
      this.$store.dispatch("savePackageIds", packageIds);
      if (this.shippingRouteType == 'intra-state') {
        this.getCostEngineByShipping()
      }
      this.createShippingId();
    },
    async createShippingId() {
      const payload = {
        payload: {
          id: this.$store.state.bookingModule.shippingId,
          shipperLocationId: this.$store.getters.takeOffLocationId,
          consigneeLocationId: this.$store.getters.deliveryLocationId,
          paymentStatus: "Not paid",
          shippingServiceId: null,
          deliveryConfirmation: false,
          shippingMethod: this.$store.state.bookingModule.newBooking.shippingMethod,
          currentStep: 3,
          shipmentType: this.packageShipmentType
        },
      };



      this.$_createShippingId(payload)
        .then((response) => {
          this.$store.dispatch("saveShippingId", response.data.data.shipping.id);

          this.$store.dispatch("saveBookingInformation", {
            property: "shippingInformation",
            value: response.data.data.shipping,
          });

          this.$emit("change-form");
        })
        .catch((e) => {
          this.handleError(e);
        });
      this.isLoading = false;
    },
    async getCostEngineByShipping() {
      const payload = {
        shippingId: this.$store.state.bookingModule.shippingId,
        type: "single",
      };

      try {
        const response = await this.$_getCostEngineByShipping(payload);

        this.$store.dispatch("saveCostTypes", response.data.data.standardCost);
        this.$store.dispatch("saveCostType", response.data.data.standardCost);

        this.costs = response.data.data;

      } catch (error) {
        this.handleError(error);
      }
    },
    goBack() {
      if (this.isPackageSelect) {
        this.$emit("back-one-form");
      } else {
        this.isPackageSelect = true;
      }
    },
  },
  computed: {
    getShipmentWeight() {
      let consolidations = this.$store.state.consolidationModule.consolidations
      let consolidation = consolidations.find(x => x.id == this.$route.query.consolidationId)

      let packageWeights = 0;
      consolidation?.shippings.forEach((item) => {

        item?.packagees.forEach((packagees) => {
          if (packagees.estimatedWeight) {
            packageWeights += packagees.estimatedWeight
          }
        })

      });

      return packageWeights
    },
    getItemValue() {
      let consolidations = this.$store.state.consolidationModule.consolidations
      let consolidation = consolidations.find(x => x.id == this.$route.query.consolidationId)

      let itemsValue = 0;
      consolidation?.shippings.forEach((item) => {

        item?.packagees.forEach((packagees) => {
          if (packagees.itemValue) {
            itemsValue += packagees.itemValue
          }
        })

      });

      return itemsValue
    },
    shippingRouteType() {
      return this.$store.state.bookingModule.newBooking.routeType;
    }

  }
};
</script>

<style lang="scss" scoped>
.booking-form__package {
  padding: 2rem 2.5rem;
}

.label {
  color: var(--primaryblue);
  font-size: 0.9rem;
  font-weight: 500;
}

.check-label {
  font-size: 0.9rem;
}

.input {
  background: #fbfcfe;
  border: 1px solid #dae8f6;
  box-sizing: border-box;
  backdrop-filter: blur(6px);
  border-radius: 2px;
}

.input::placeholder {
  color: #bec4d5;
}

.input-wrapper {
  width: 90%;
  margin: 0 auto 2rem;
}

svg {
  display: inline-block;
}

.radio-label span::after {
  background: #bec4d5;
}

.shipment-types {
  display: flex;
}

h3 {
  font-size: 1.15rem !important;
}

.shipment-type {
  padding: 1rem 0.5rem;
  background: #fbfcfe;
  border: 1px solid #dae8f6;
  box-sizing: border-box;
  border-radius: 3px;
  margin: 1rem;
  width: 8rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;

  p {
    font-size: 0.9rem;
    padding-top: 0.5rem;
  }
}

.shipment-type.selected {
  background: var(--primaryblue);
  color: #ffffff;

  svg path {
    fill: #ffffff;
  }
}

.add-package-btn {
  cursor: pointer;
  background: #fbfcfe;
  border: 1px solid #dae8f6;
  box-sizing: border-box;
  border-radius: 2px;
  padding: 1rem;
  margin: 1.5rem 0;

  span {
    color: var(--amber);
  }
}
</style>
